import { useContext } from "react";
import { ContextVersion } from "../contexts/version.context";

const useVersion = () => {
    const { version, setVersion } = useContext(ContextVersion);
    
    return { version, setVersion };
}

export default useVersion;

